import { Box } from '@mui/material';
import { RenderTable } from '../../../../../components/ui';
import TBody from './TBody';
import THead from './THead';
import { IData } from '../../helpers/interface';
import TFoot from './TFoot';

interface IProps {
  moduleData: IData;
  isView: boolean;
  setUseEffectRender: any;
  handelDeleteRows: any;
  setIsOpenPopupRejections: any;
  setRejectionsIndx: any;
  setIsOpenPopupForScheduleDowntime: any;
}

const TController = ({
  moduleData,
  isView,
  handelDeleteRows,
  setUseEffectRender,
  setIsOpenPopupForScheduleDowntime,

  setIsOpenPopupRejections,
  setRejectionsIndx,
}: IProps) => {
  return (
    <Box>
      <RenderTable>
        <THead
          {...{
            moduleData,
            isView,
            setUseEffectRender,
          }}
        />
        <TBody
          {...{
            moduleData,
            isView,
            handelDeleteRows,
            setIsOpenPopupRejections,
            setIsOpenPopupForScheduleDowntime,
            setRejectionsIndx,
          }}
        />
        <TFoot {...{ moduleData, isView }} />
      </RenderTable>
    </Box>
  );
};

export default TController;
